export default __webpack_public_path__ + "static/media/twitter.b13caa07.svg";